import { render } from "./TrickListView.vue?vue&type=template&id=713d3535&scoped=true"
import script from "./TrickListView.vue?vue&type=script&lang=js"
export * from "./TrickListView.vue?vue&type=script&lang=js"

import "./TrickListView.vue?vue&type=style&index=0&id=713d3535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713d3535"]])

export default __exports__